import { useParams,useNavigate } from "react-router-dom"
import { useState,useEffect } from "react"
import { Container } from "@mui/material"

import ProjectForm from "./ProjectForm"
import { baseURL } from "../../Config/config";
import Navbar from "../CommonC/SelexSolNavbar";
import BgContainer2 from "../CommonC/BgContainer2";



function AdminEditProject(){

const {project_id} = useParams()

const navigate = useNavigate()


const [project, setproject] = useState({
  title: "",
  slug: "",
  description: "",
  author: "",
  image: "",
  content: "",
});



const editProject = async ()=>{
  const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(project),
      };
      try {
        let res = await fetch(`${baseURL}/editoptimizeprojects`, requestOptions);
        res = await res.json(); 
        if (res.code) {
          navigate("/adminhome")
          return;
        }
        alert("Some Error");
      } catch (error) {
        alert("Some Error", error);
        console.log("err", error);
      }

}
useEffect(() => {
  getAllprojects();
}, [project_id]);

const getAllprojects = async () => {
  try {
    let result = await fetch(`${baseURL}/getallprojects`);
    result = await result.json();

    if (result.code) {
      const allprojects = result.data;

      // find selected blog
      const selectedproject = allprojects.find(
        (b) => String(b.project_id) === String(project_id)
      );

      // set state
      if (selectedproject) {
        setproject({
          title: selectedproject.title || "",
          slug: selectedproject.slug || "",
          description: selectedproject.description || "",
          author: selectedproject.author || "",
          date: selectedproject.date || "",
          image: selectedproject.image || "",
          content: selectedproject.content || "",
          project_id: selectedproject.project_id || "",
        });
      }

      return;
    }

    alert("There was some error");
  } catch (error) {
    console.log("error", error);
  }
};


return(

 <div
        style={{
          height:window.screen.height
        }}
      >
       
        <Navbar admin={true}/>
<Container sx={{background:"white", maxHeight: "750px",overflowY: "auto",marginTop:"15px",padding:"10px"}}>


<ProjectForm
project={project}
setProject={setproject}
onSubmit={editProject}
editStatus = {true}
/>

</Container>
</div>

)

}

export default AdminEditProject